import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/vi'

import {FC} from 'react'
import {IntlProvider} from 'react-intl'
// import deMessages from './messages/de.json'
import enMessages from './messages/en.json'
import {useLang} from './Metronici18n'
import viMessages from './messages/vi.json'

// import esMessages from './messages/es.json'
// import frMessages from './messages/fr.json'
// import jaMessages from './messages/ja.json'
// import zhMessages from './messages/zh.json'

const allMessages = {
  vi: viMessages,
  en: enMessages,
}

const I18nProvider: FC = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
